import { useState, useCallback } from 'react';
import { StudentSearchResult } from '../types/student-search';
import { studentSearchService } from '../services/studentSearchService';
import { useToast } from './useToast';

interface UseStudentDetailState {
  student: StudentSearchResult | null;
  loading: boolean;
  error: string | null;
  isOpen: boolean;
}

export const useStudentDetail = () => {
  const [state, setState] = useState<UseStudentDetailState>({
    student: null,
    loading: false,
    error: null,
    isOpen: false,
  });

  const { showToast } = useToast();

  // 学生詳細取得
  const fetchStudentDetail = useCallback(
    async (studentId: number) => {
      setState((prev) => ({ ...prev, loading: true, error: null }));

      try {
        const response = await studentSearchService.getStudentDetail(studentId);
        setState((prev) => ({
          ...prev,
          student: response.data.student,
          loading: false,
          isOpen: true,
        }));
      } catch (error) {
        const errorMessage =
          error instanceof Error
            ? error.message
            : '学生詳細の取得に失敗しました';
        setState((prev) => ({
          ...prev,
          loading: false,
          error: errorMessage,
          isOpen: false,
        }));
        showToast(errorMessage, 'error');
      }
    },
    [showToast]
  );

  // モーダルを開く
  const openDetail = useCallback(
    (studentId: number) => {
      fetchStudentDetail(studentId);
    },
    [fetchStudentDetail]
  );

  // モーダルを閉じる
  const closeDetail = useCallback(() => {
    setState((prev) => ({
      ...prev,
      isOpen: false,
      student: null,
      error: null,
    }));
  }, []);

  return {
    // 状態
    student: state.student,
    loading: state.loading,
    error: state.error,
    isOpen: state.isOpen,

    // アクション
    openDetail,
    closeDetail,
  };
};
